import { getShowJSONContextItem, useCallbackRef, useGetDefaultContextMenuItems, useJsonModal } from '@talos/kyoko';
import type { GetContextMenuItemsParams } from 'ag-grid-community';
import { compact } from 'lodash-es';
import { useMemo } from 'react';
import type { NotificationWithToastInfo } from './useEnrichNotificationsPipe';

export function useNotificationsMenu() {
  const { handleClickJson, jsonModal } = useJsonModal();
  const getDefaultContextMenuItems = useGetDefaultContextMenuItems();

  const getContextMenuItems = useCallbackRef((params: GetContextMenuItemsParams<NotificationWithToastInfo>) => {
    return compact([
      getShowJSONContextItem({ params, handleClickJson }),
      'separator',
      ...getDefaultContextMenuItems(params),
    ]);
  });

  const dialogs = useMemo(() => <>{jsonModal}</>, [jsonModal]);

  return {
    getContextMenuItems,
    dialogs,
  };
}
